import { render, staticRenderFns } from "./alert-create.vue?vue&type=template&id=0200586d&"
import script from "./alert-create.vue?vue&type=script&lang=js&"
export * from "./alert-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports